import baseRequest from "../_core/baseRequest";
const namingRules = {};

export default {
    getPaymentPeriodList: params => baseRequest.get("/payment-period", params),
    createPaymentPeriod: params => baseRequest.post(`/payment-period`, params),
    updatePaymentPeriod: params => baseRequest.put(`/payment-period/${params._id}`, params),
    deletePaymentPeriod: params => baseRequest.post(`/payment-period/delete/${params._id}`),
    sentNotificationPaymentPeriod: params =>
        baseRequest.post(
            `/payment-period/send-sms/${params._id}?isTestNotification=${params.isTestNotification}`,
            params
        ),
    paymentPeriodWithNames: params => baseRequest.get(`/payment-period/with-names`, params),
    calculateAndProcess: params =>
        baseRequest.post(`/payment-period/${params.periodId}/calculate-and-process`, params)
};
